<template>
  <div>
    <el-dialog title="关联税收分类"
               :visible.sync="dialogVisible"
               width="50%">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入税收分类编码"
                    v-model="query.categoryCode"></el-input>
        </el-col>
        <el-col :span="14">
          <el-input placeholder="请输入分类名称、简称或说明中的关键字搜索"
                    v-model="query.searchText"></el-input>
        </el-col>
        <el-button plain
                   @click="getInfoList">查询</el-button>
      </el-row>
      <br>
      <el-table :data="info"
                v-if="info"
                ref="multipleTable"
                max-height="250"
                style="width: 100%;"
                @current-change="handleSelectionChange">
        <el-table-column label="选择"
                         fixed
                         width="55">
          　<template slot-scope="scope">
            　　　　　　<el-radio v-model="tableRadio"
                      :label="scope.row"><i></i></el-radio>
            　　　　</template>
        </el-table-column>
        <el-table-column prop="categoryCode"
                         label="税收分类编码"
                         width="180">
        </el-table-column>
        <el-table-column prop="categoryName"
                         label="税收分类名称"
                         width="180">
        </el-table-column>
        <el-table-column prop="categoryAbbr"
                         label="简称">
        </el-table-column>
        <el-table-column prop="categoryRemarks"
                         label="说明">
          <template slot-scope="scope">

            <el-tooltip placement="left-start">
              <div slot="content">{{scope.row.categoryRemarks}}</div>
              <span style="">{{scope.row.categoryRemarks}}</span>
            </el-tooltip>
          </template>

        </el-table-column>
        <el-table-column label="选择税率">

          <template slot-scope="scope">
            <span v-if="scope.row.rates.length==1">
              <span v-for="item in scope.row.rates"
                    :key="item.value">{{item.value}}</span>
            </span>
            　　　　　　<el-select v-else
                       v-model="scope.row.taxRateString">
              <el-option v-for="item in scope.row.rates"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>

            　　　　</template>

        </el-table-column>
      </el-table>

      <span slot="footer"
            v-if="info"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import _invoiceContent from '@/service/invoice-content-service'
export default {
  data () {
    return {
      dialogVisible: false,
      id: null,
      name: null,
      info: null,
      tableRadio: [],
      query: {
        searchText: null,
        categoryCode: null,
        pageIndex: 1,
        pageSize: 20

      }
    };
  },
  methods: {
    submitForm () {
      if (this.tableRadio.length == 0) {
        this.$message({
          message: '请选择关联数据',
        });
        return false;
      }
      if (!this.tableRadio.taxRateString) {
        this.$message({
          message: '请选择税率',
        });
        return false;
      }

      _invoiceContent.addOrUpdateCategory(this.tableRadio, () => {

        this.$notify({
          message: '关联成功',
          type: 'success'
        });
        this.dialogVisible = false
        location.reload();
      }, response => {
        this.$notify({
          message: response,
          type: 'warning'
        })
      })

    },
    handleSelectionChange (val) {
      console.log(val)

      this.tableRadio = val;
      if (val.rates.length == 1) {
        this.tableRadio.taxRateString = val.rates[0].value

      }
      this.$set(this.tableRadio, 'id', this.id)
      this.$set(this.tableRadio, 'name', this.name)


    },
    show (id, name) {
      this.info = null
      this.query = {}
      if (this.info) {
        this.info.forEach(item => {
          item.taxRateString = ''
        })
      }
      this.tableRadio = []
      this.id = id;
      this.name = name
      this.dialogVisible = true;
    },
    getInfoList () {
      if (this.query.categoryCode == null && this.query.searchText == null) {
        this.$message({
          message: '没有要查询的内容',
        });
        return false
      }
      _invoiceContent.getTaxCategoryList(this.query, response => {
        this.info = response
      }, response => {
        this.$notify({
          message: response,
          type: 'warning'
        })
      })


    }
  },

};
</script>
<style>
.el-tooltip__popper {
  max-width: 500px;
  line-height: 20px;
}
</style>